module.exports = __webpack_public_path__ + "img/noimage.6263c49e.jpg";